<div class="main-content">
  <div class="panel mb-30">
    <div class="panel-header">
      <h5>Custom Editor Playground</h5>
    </div>
    <div class="panel-body">
      <form [formGroup]="form">
        <ce-custom-editor
          formControlName="content"
          [uploadFn]="handleImageUpload">
        </ce-custom-editor>
      </form>
      <div class="mt-3">
        <label class="form-label">Output HTML</label>
        <textarea
          class="form-control"
          rows="6"
          [value]="form.value.content || ''"
          readonly>
        </textarea>
      </div>
    </div>
  </div>
</div>
